export default __webpack_public_path__ + "static/Room-With-A-View-Big-Ben-356d1f60ff21a00d3d9c5139ddef1939.jpg";